import left from '../../assets/img/games/left.webp';
import right from '../../assets/img/games/right.webp';
import char from '../../assets/img/games/charbox.webp';
import next from '../../assets/img/screens/next.webp';
import back from '../../assets/img/screens/back.webp';
import note from '../../assets/img/games/note.webp';
import home from '../../assets/img/games/home.webp';
import dial from '../../assets/img/games/Dialogue.webp';
import parch from '../../assets/img/games/parch.webp';
import rew from '../../assets/img/screens/Reward Bar.webp';
import bar from '../../assets/img/screens/Bar.webp';
import fill from '../../assets/img/screens/Fill.webp';
import bull from '../../assets/img/screens/bullet.webp';
import batch from '../../assets/img/screens/upback.webp';
import feedi from '../../assets/img/screens/feed.webp';
import Completion from '../../assets/img/screens/ChapterCompleteBackground.webp';
import Screen1 from '../../assets/img/screens/ChapterCompleteBackground.webp';
import Screen2 from '../../assets/img/screens/screen2.webp';
import Screen4 from '../../assets/img/screens/takeaway.webp';
import Screen5 from '../../assets/img/screens/welcome.webp';
import Screen6 from '../../assets/img/games/Thankyou/ThankyouBg.webp';
import TYDesign from 'assets/img/games/Thankyou/ThankyouBgDesign.webp';
import ComDesign from 'assets/img/games/Thankyou/ChapterCompleteBackgroundDesign.webp';
import TkDesign from 'assets/img/games/Thankyou/takeawayDesign.webp';
import RefScreen1 from '../../assets/img/screens/refscreen1.webp';
import point from '../../assets/img/screens/points.webp';
import skill from '../../assets/img/games/Gameplay/skillsArrow.webp';
import take from '../../assets/img/screens/takeaway.webp';
import RefBg from '../../assets/img/games/refbg.webp';
import question from '../../assets/img/games/question.webp';
import qs from '../../assets/img/screens/QS.webp';
import ref from '../../assets/img/screens/refquestions.webp';
import Lead from '../../assets/img/screens/Leaderboard.webp';
import Replay from '../../assets/img/screens/Replay.webp';
import QueueBackground from '../../assets/img/games/Quest_background.webp';
import QueueScreen from '../../assets/img/games/Queue_screen.webp';
import Lock from '../../assets/img/games/Block Frame.webp';
import Select from '../../assets/img/games/select_character.webp';
import Entry from '../../assets/img/games/entry.webp';
import Label from '../../assets/img/games/label.webp';
import Close from '../../assets/img/games/close.webp';
import Arrow from '../../assets/img/games/arrow.webp';
import Separator from '../../assets/img/games/separator.webp';
import ReplayBox from '../../assets/img/screens/ReplayBox.webp';
import overview from '../../assets/img/screens/overview.webp';
import play from '../../assets/img/games/Play.webp';
import ArcheryArrow from '../../assets/img/games/archery-arrow.webp';
import ProfileCard from '../../assets/img/games/profile-card.webp';
import FormField from '../../assets/img/games/formfield.webp';
import NextBtn from '../../assets/img/games/NextButton.webp';
import Selected from '../../assets/img/games/selected.webp';
import refsep from '../../assets/img/games/refseparate.webp';
import Login from '../../assets/img/games/log_non.webp';
import on from '../../assets/img/games/on.webp';
import Lang from 'assets/img/games/lang.webp';
import off from '../../assets/img/games/off.webp';
import replayBtn from '../../assets/img/games/ReplayBtn.webp';
import SelectButton from '../../assets/img/games/selectbtn.webp';
import Okay from '../../assets/img/games/Okay.webp';
import write from '../../assets/img/screens/Writing.webp';
import feedparch from 'assets/img/games/parchment.webp';
import TopMenu from '../../assets/img/games/top-menu.webp';
import Overview from '../../assets/img/games/game-overview.webp';
import ReplayPointBg from '../../assets/img/games/replay-point-bg.webp';
import Setting from '../../assets/img/games/settings.webp';
import SettingPad from '../../assets/img/games/setting-pad.webp';
import SettingPad_IOS from '../../assets/img/games/settingpad_ios.webp';
import SliderPointer from '../../assets/img/games/slider-pointer.webp';
import Tooltip from 'assets/img/games/tooltip.webp';
import Ans from 'assets/img/games/ANS.webp';
import download from '../../assets/img/games/download.png';
import Fb from 'assets/img/games/FB.webp';
import Completed from 'assets/img/games/COMPLETED.webp';
import VolumeTrack from 'assets/img/games/volume-track.webp';
import Thankyou from 'assets/img/games/Thankyou/ThankyouBg.webp';
import SkillLearn from 'assets/img/screens/Skills&Learningoutcome.webp';
import ProgressBar from 'assets/img/games/Progress.webp';
import Scorebox from 'assets/img/games/Score.webp';
import Profile from 'assets/img/games/profile.webp';
import Continue from 'assets/img/games/Continue.webp';
import Yes from 'assets/img/games/YesButton.webp';
import No from 'assets/img/games/NoButton.webp';
import MoneyIcon from 'assets/img/games/MoneyIcon.webp';
import profile from '../../assets/img/games/profile.webp';
import cancel from 'assets/img/games/cancel.webp';
import leadBtn from 'assets/img/games/LeadBtn.webp';
import ModelQ from 'assets/img/games/modelq.webp';
import scroll from 'assets/img/games/scroll.webp';
import Cross from 'assets/img/games/cross.webp';
import introBgImage from 'assets/img/games/Gameplay/Game-play-bg-without-blur.webp';
import redLang from 'assets/img/games/Gameplay/Language-new1.webp';
import backBtn from 'assets/img/games/BackButton.webp';
import closeBtn from 'assets/img/games/CloseButton.webp';
import mapBtn from 'assets/img/games/map.webp';
import Author from 'assets/img/games/Gameplay/authorArrow.webp';
import NoteArrow from 'assets/img/games/Gameplay/noteArrow.webp';
import learningOutcome from 'assets/img/games/Gameplay/learningOutcome.webp';
import skillsArrow from 'assets/img/screens/Skills.webp';
import blueBlurBg from 'assets/img/games/Gameplay/Game-play-bg-with-blur.webp';
import MedievalMale from 'assets/img/CharacterSelectMediImg/Medieval1.webp';
import MedievalFemale from 'assets/img/CharacterSelectMediImg/Medieval2.webp';
import FutureMale from 'assets/img/CharacterSelectfutImg/Futuristic1.webp';
import FutureFemale from 'assets/img/CharacterSelectfutImg/Futuristic2.webp';
import RealFemale from 'assets/img/CharacterSelectRealImg/RealFemaleUser.webp';
import RealMale from 'assets/img/CharacterSelectRealImg/RealMaleUser.webp';
import MagicalMale from 'assets/img/CharacterSelectMagiImg/MagicalMaleUser.webp';
import MagicalFemale from 'assets/img/CharacterSelectMagiImg/MagicalFemaleUser.webp';
//for character selection page
import Medieval from 'assets/img/nonPlayer/1. MedievalArtisan.webp';
import MedievalCastleMember from 'assets/img/nonPlayer/2. MedievalCastleMember.webp';
import MedievalMerchant from 'assets/img/nonPlayer/3. MedIievalMerchant.webp';
import FuturisticCarOwner from 'assets/img/nonPlayer/4.FuturisticCarOwner.webp';
import FuturisticScientist from 'assets/img/nonPlayer/5.FuturisticScientist.webp';
import FuturisticTeamMember from 'assets/img/nonPlayer/6.FuturisticTeamMember.webp';
import RealFactorySupervisor from 'assets/img/nonPlayer/RealFactorySupervisor.webp';
import RealFemaleManager from 'assets/img/nonPlayer/RealFemaleManager.webp';
import RealTeamMember from 'assets/img/nonPlayer/RealTeamMember.webp';
import MagicalFemaleEnchantress from 'assets/img/nonPlayer/MagicalFemaleEnchantress.webp';
import MagicalMaleWizard from 'assets/img/nonPlayer/MagicalMaleWizard.webp';
import MagicalFemalePotionSage from 'assets/img/nonPlayer/MagicalFemalePotionSage.webp';

// full_Image
import Medieval_full_Image from 'assets/img/nonPlayerNpcFullImage/1.Medieval_full_Image.webp';
import MedievalCastleMember_full_Image from 'assets/img/nonPlayerNpcFullImage/2.MedievalCastleMember_full_Image.webp';
import MedievalMerchant_full_Image from 'assets/img/nonPlayerNpcFullImage/3.MedIievalMerchant_full_Image.webp';
import FuturisticCarOwner_full_Image from 'assets/img/nonPlayerNpcFullImage/4.FuturisticCarOwner_full_Image.webp';
import Iris from 'assets/img/nonPlayerNpcFullImage/FemaleNPCIris_2.png'
import Nova from 'assets/img/nonPlayerNpcFullImage/FemaleNPCNova_2.png'
import Axel from 'assets/img/nonPlayerNpcFullImage/MaleNPCAxel2.png'
import Riven from 'assets/img/nonPlayerNpcFullImage/MaleNPCRiven_2.png'
import FuturisticScientist_full_Image from 'assets/img/nonPlayerNpcFullImage/5.FuturisticScientist_full_Image.webp';
import FuturisticTeamMember_full_Image from 'assets/img/nonPlayerNpcFullImage/6.FuturisticTeamMember_full_Image.webp';
import RealFactorySupervisor_full_Image from 'assets/img/nonPlayerNpcFullImage/RealFactorySupervisor_full_Image.webp';
import RealFemaleManager_full_Image from 'assets/img/nonPlayerNpcFullImage/RealFemaleManager_full_Image.webp';
import RealTeamMember_full_Image from 'assets/img/nonPlayerNpcFullImage/RealTeamMember_full_Image.webp';
import MagicalFemaleEnchantress_full_Image from 'assets/img/nonPlayerNpcFullImage/MagicalFemaleEnchantress_full_Image.webp';
import MagicalMaleWizard_full_Image from 'assets/img/nonPlayerNpcFullImage/MagicalMaleWizard_full_Image.webp';
import MagicalFemalePotionSage_full_Image from 'assets/img/nonPlayerNpcFullImage/MagicalFemalePotionSage_full_Image.webp';
//screenshot
import Medival_Office from 'assets/img/BackgroundScreen/Medieval office.webp';
import Medieval_emporium from 'assets/img/BackgroundScreen/Medieval emporium.webp';
import Medieval_castle from 'assets/img/BackgroundScreen/Medieval castle.webp';
import Magical_underground from 'assets/img/BackgroundScreen/Magical underground.webp';
import Magical_office from 'assets/img/BackgroundScreen/Magical office.webp';
import Futuristic_Lab from 'assets/img/BackgroundScreen/Futuristic Lab.webp';
import Futuristic_City from 'assets/img/BackgroundScreen/Futuristic City.webp';
import Realistic_office from 'assets/img/BackgroundScreen/Realistic office.webp';
import Magical_garden from 'assets/img/BackgroundScreen/Magical garden.webp';
import Realistic_Factory from 'assets/img/BackgroundScreen/Realistic Factory.webp';
import Realistic_workplace from 'assets/img/BackgroundScreen/Realistic workplace.webp';
import Futuristic_office from 'assets/img/BackgroundScreen/Futuristic office.webp';

export const assetImageSrc = [
  { assetType: 'TYDesign', src: TYDesign },
  { assetType: 'ComDesign', src: ComDesign },
  { assetType: 'TkDesign', src: TkDesign },
  { assetType: 'Author', src: Author },
  { assetType: 'NoteArrow', src: NoteArrow },
  { assetType: 'LearnOut', src: learningOutcome },
  { assetType: 'Skill', src: skillsArrow },
  { assetType: 'Yes', src: Yes },
  { assetType: 'No', src: No },
  { assetType: 'backBtn', src: backBtn },
  { assetType: 'scroll', src: scroll },
  { assetType: 'Cross', src: Cross },
  { assetType: 'ModelQ', src: ModelQ },
  { assetType: 'leadBtn', src: leadBtn },
  { assetType: 'cancel', src: cancel },
  { assetType: 'VolumeTrack', src: VolumeTrack },
  { assetType: 'Continue', src: Continue },
  { assetType: 'Profile', src: Profile },
  { assetType: 'ProgressBar', src: ProgressBar },
  { assetType: 'Scorebox', src: Scorebox },
  { assetType: 'left', src: left },
  { assetType: 'right', src: right },
  { assetType: 'char', src: char },
  { assetType: 'next', src: next },
  { assetType: 'back', src: back },
  { assetType: 'note', src: note },
  { assetType: 'home', src: home },
  { assetType: 'dial', src: dial },
  { assetType: 'parch', src: parch },
  { assetType: 'rew', src: rew },
  { assetType: 'bar', src: bar },
  { assetType: 'fill', src: fill },
  { assetType: 'bull', src: bull },
   { assetType: 'download', src: download },
  { assetType: 'batch', src: batch },
  { assetType: 'feedi', src: feedi },
  { assetType: 'Completion', src: Completion },
  { assetType: 'Screen1', src: Screen1 },
  { assetType: 'Screen2', src: Screen2 },
  { assetType: 'Screen4', src: Screen4 },
  { assetType: 'Screen5', src: Screen5 },
  { assetType: 'Screen6', src: Screen6 },
  { assetType: 'RefScreen1', src: RefScreen1 },
  { assetType: 'point', src: point },
  { assetType: 'skill', src: skill },
  { assetType: 'take', src: take },
  { assetType: 'RefBg', src: RefBg },
  { assetType: 'question', src: question },
  { assetType: 'qs', src: qs },
  { assetType: 'ref', src: ref },
  { assetType: 'Lead', src: Lead },
  { assetType: 'Replay', src: Replay },
  { assetType: 'QueueBackground', src: QueueBackground },
  { assetType: 'QueueScreen', src: QueueScreen },
  { assetType: 'Lock', src: Lock },
  { assetType: 'Select', src: Select },
  { assetType: 'Entry', src: Entry },
  { assetType: 'Label', src: Label },
  { assetType: 'Close', src: Close },
  { assetType: 'Arrow', src: Arrow },
  { assetType: 'Separator', src: Separator },
  { assetType: 'ReplayBox', src: ReplayBox },
  { assetType: 'overview', src: overview },
  { assetType: 'ArcheryArrow', src: ArcheryArrow },
  { assetType: 'ProfileCard', src: ProfileCard },
  { assetType: 'FormField', src: FormField },
  { assetType: 'NextBtn', src: NextBtn },
  { assetType: 'Selected', src: Selected },
  { assetType: 'refsep', src: refsep },
  { assetType: 'Login', src: Login },
  { assetType: 'on', src: on },
  { assetType: 'off', src: off },
  { assetType: 'play', src: play },
  { assetType: 'replayBtn', src: replayBtn },
  { assetType: 'SelectButton', src: SelectButton },
  { assetType: 'OkayBtn', src: Okay },
  { assetType: 'TopMenu', src: TopMenu },
  { assetType: 'Overview', src: Overview },
  { assetType: 'ReplayPointBg', src: ReplayPointBg },
  { assetType: 'Setting', src: Setting },
  { assetType: 'SettingPad', src: SettingPad },
    { assetType: 'SettingPad_IOS', src: SettingPad_IOS },
  { assetType: 'SliderPointer', src: SliderPointer },
  { assetType: 'write', src: write },
  { assetType: 'Lang', src: Lang },
  { assetType: 'TooltipImg', src: Tooltip },
  { assetType: 'feedparch', src: feedparch },
  { assetType: 'ANS', src: Ans },
  { assetType: 'FB', src: Fb },
  { assetType: 'Completed', src: Completed },
  { assetType: 'Thankyou', src: Thankyou },
  { assetType: 'SkillLearn', src: SkillLearn },
  { assetType: 'MoneyIcon', src: MoneyIcon },
  { assetType: 'profile', src: profile },
  { assetType: 'redLang', src: redLang },
  { assetType: 'introBgImage', src: introBgImage },
  { assetType: 'closeBtn', src: closeBtn },
  { assetType: 'blueBlurBg', src: blueBlurBg },
  { assetType: 'mapBtn', src: mapBtn },
  {
    assetType: 'Player_Image',
    src: [
      {
        theme: 'Medieval',
        id: 'male',
        name: 'MedievalMaleUser',
        src: MedievalMale,
      },
      {
        theme: 'Medieval',
        id: 'female',
        name: 'MedievalFemaleUser',
        src: MedievalFemale,
      },
      {
        theme: 'Future',
        id: 'male',
        name: 'FuturisticMaleUser',
        src: FutureMale,
      },
      {
        theme: 'Future',
        id: 'female',
        name: 'FuturisticFemaleUser',
        src: FutureFemale,
      },
      { theme: 'Real', id: 'male', name: 'RealMaleUser', src: RealMale },
      { theme: 'Real', id: 'female', name: 'RealFemaleUser', src: RealFemale },
      {
        theme: 'Magical',
        id: 'male',
        name: 'MagicalMaleUser',
        src: MagicalMale,
      },
      {
        theme: 'Magical',
        id: 'female',
        name: 'MagicalFemaleUser',
        src: MagicalFemale,
      },
    ],
  },
  {
    assetType: 'character_Image',
    src: [
      { theme: 'Medieval', pose: 'half', name: 'Evelina', src: Medieval },
      {
        theme: 'Medieval',
        pose: 'full',
        name: 'Evelina',
        src: Medieval_full_Image,
      },
      {
        theme: 'MedievalCastleMember',
        pose: 'half',
        name: 'Tristan',
        src: MedievalCastleMember,
      },
      {
        theme: 'MedievalCastleMember',
        pose: 'full',
        name: 'Tristan',
        src: MedievalCastleMember_full_Image,
      },
      {
        theme: 'MedievalMerchant',
        pose: 'half',
        name: 'Belthor',
        src: MedievalMerchant,
      },
      {
        theme: 'MedievalMerchant',
        pose: 'full',
        name: 'Belthor',
        src: MedievalMerchant_full_Image,
      },
      {
        theme: 'FuturisticCarOwner',
        pose: 'half',
        name: 'Elina',
        src: FuturisticCarOwner,
      },
      {
        theme: 'FuturisticCarOwner',
        pose: 'full',
        name: 'Elina',
        src: FuturisticCarOwner_full_Image,
      },
      {
        theme: 'FuturisticCarOwner',
        pose: 'full',
        name: 'Iris',
        src: Iris,
      },
      {
        theme: 'FuturisticCarOwner',
        pose: 'full',
        name: 'Nova',
        src: Nova,
      },
      {
        theme: 'FuturisticCarOwner',
        pose: 'full',
        name: 'Axel',
        src: Axel,
      },
      {
        theme: 'FuturisticCarOwner',
        pose: 'full',
        name: 'Riven',
        src: Riven,
      },
      {
        theme: 'FuturisticScientist',
        pose: 'half',
        name: 'Zane',
        src: FuturisticScientist,
      },
      {
        theme: 'FuturisticScientist',
        pose: 'full',
        name: 'Zane',
        src: FuturisticScientist_full_Image,
      },
      {
        theme: 'FuturisticTeamMember',
        pose: 'half',
        name: 'Lena',
        src: FuturisticTeamMember,
      },
      {
        theme: 'FuturisticTeamMember',
        pose: 'full',
        name: 'Lena',
        src: FuturisticTeamMember_full_Image,
      },
      {
        theme: 'RealFactorySupervisor',
        pose: 'half',
        name: 'Lucas',
        src: RealFactorySupervisor,
      },
      {
        theme: 'RealFactorySupervisor',
        pose: 'full',
        name: 'Lucas',
        src: RealFactorySupervisor_full_Image,
      },
      {
        theme: 'RealFemaleManager',
        pose: 'half',
        name: 'Olivia',
        src: RealFemaleManager,
      },
      {
        theme: 'RealFemaleManager',
        pose: 'full',
        name: 'Olivia',
        src: RealFemaleManager_full_Image,
      },
      {
        theme: 'RealTeamMember',
        pose: 'full',
        name: 'Ryan',
        src: RealTeamMember_full_Image,
      },
      {
        theme: 'RealTeamMember',
        pose: 'half',
        name: 'Ryan',
        src: RealTeamMember,
      },
      {
        theme: 'MagicalFemaleEnchantress',
        pose: 'full',
        name: 'Thalassa',
        src: MagicalFemaleEnchantress_full_Image,
      },
      {
        theme: 'MagicalFemaleEnchantress',
        pose: 'half',
        name: 'Thalassa',
        src: MagicalFemaleEnchantress,
      },
      {
        theme: 'MagicalMaleWizard',
        pose: 'full',
        name: 'Eldrin',
        src: MagicalMaleWizard_full_Image,
      },
      {
        theme: 'MagicalMaleWizard',
        pose: 'half',
        name: 'Eldrin',
        src: MagicalMaleWizard,
      },
      {
        theme: 'MagicalFemalePotionSage',
        pose: 'full',
        name: 'Nerina',
        src: MagicalFemalePotionSage_full_Image,
      },
      {
        theme: 'MagicalFemalePotionSage',
        pose: 'half',
        name: 'Nerina',
        src: MagicalFemalePotionSage,
      },
    ],
  },
  {
    assetType: 'BackgroundScreenshots',
    src: [
      { name: 'Medieval office', src: Medival_Office },
      { name: 'Medieval emporium', src: Medieval_emporium },
      { name: 'Medieval castle', src: Medieval_castle },
      { name: 'Magical underground', src: Magical_underground },
      { name: 'Magical office', src: Magical_office },
      { name: 'Futuristic Lab', src: Futuristic_Lab },
      { name: 'Futuristic City', src: Futuristic_City },
      { name: 'Realistic office', src: Realistic_office },
      { name: 'Futuristic office', src: Futuristic_office },
      { name: 'Realistic workplace', src: Realistic_workplace },
      { name: 'Realistic Factory', src: Realistic_Factory },
      { name: 'Magical garden', src: Magical_garden },
    ],
  },
];
